export const initFlixxHero = function (config) {
  if ($('.flixx_hero').length > 0) {
    $('.flixx_hero').each(function () {
      let el = this;
      let $interfererBox = $('.interferer-top', this)
      let $infoBoxCloseButton = $('.interferer-top button', this);

      // Click to close info box
      $infoBoxCloseButton.on('click', function () {
        $interfererBox.fadeOut();
      });

      // ESC key to close info box
      $(document).bind('keydown', function (e) {
        if ((e.which == 27)) {
          console.log('Triggered ESC key. Close interferer box.');
          $interfererBox.fadeOut();
        }
      });
    });
  }
}
